<template>
  <modal-base @clickOverlay="$emit('onClickOverlay')" class="success-modal">
    <div class="success-modal__top">
      <div class="success-modal__top-text">Success!</div>
    </div>
    <div class="success-modal__bottom">
      <div class="success-modal__notice success-modal__notice_register" v-if="register">
        You've been successfully registered. In order to continue working with the application you need to follow the confirmation link sent to your email and log in.
      </div>

      <div class="success-modal__notice success-modal__notice_reset" v-else-if="reset">
      We have sent you an email with instructions to reset your password. Please, check your mailbox.
      </div>
      <button-el class="button-continue" red left large @click="clickOnCountinueBtn">
        Continue
        <icon-base slot="icon" red>
          <icon-check left />
        </icon-base>
      </button-el>
    </div>
  </modal-base>
</template>

<script>
import { IconCheck } from 'Icons';
import { mapActions } from 'vuex';
import ModalBase from 'Common/ModalBase';

export default {
  props: {
    register: Boolean,
    reset: Boolean,
    showOverlay: Boolean,
  },
  components: {
    IconCheck,
    ModalBase,
  },
  methods: {
    ...mapActions('settings', [
      'toggleLoginModal',
    ]),
    clickOnCountinueBtn() {
      if (this.isAuthorizationPage) {
        this.$emit('clickOnCountinueBtn');
        return;
      }
      this.toggleLoginModal({ val: false });
    },
  },
  computed: {
    isAuthorizationPage() {
      return this.$route.meta.isAuthorizationPage;
    },
  },
};
</script>


<style lang="scss" scoped>
.success-modal {
  &__notice {
    margin-bottom: 37px;
    @include font(13px);
    line-height: 21px;
  }
  $width: 431px;
  &__top {
    @include attachImage('success-modal__red-pattern', $width, 267px, '.jpg');
    height: 266px;
    border-radius: 5px 5px 0 0;
    position: relative;
  }
  &__top-text {
    @include font(24px, $white-color2, 500);
    position: absolute;
    left: 30px;
    bottom: 33px;
  }
  &__bottom {
    background: $white-color2;
    padding: 36px 42px 30px 33px;
    border-radius: 0 0 5px 5px;
    width: $width;
  }
}
.button-continue {
  margin-left: -2px;
  padding: 10.5px 10px 10.5px 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/loginTools/SuccessModal.vue